<template>
  <div class="card">
    <div class="card-header">
      <h3 class="card-title me-auto">Company Contacts</h3>
      <button class="btn btn-primary" @click.prevent="save" v-if="!saved">
        Save
      </button>
      <button class="btn btn-primary" @click.prevent="saveSettings" v-else>
        Saved
      </button>
    </div>
    <div class="card-body">
      <table class="table">
        <thead>
          <tr>
            <th>Receive Lead Emails</th>
            <th>Contact</th>
          </tr>
        </thead>
        <tbody>
          <contact-table-row
            v-for="contact in contacts"
            :key="`contact-${contact.contactID}`"
            :contact="contact"
          ></contact-table-row>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import SettingsService from "../../../services/SettingsService";

import ContactTableRow from "./ContactTableRow.vue";

export default {
  components: { ContactTableRow },
  name: "account.profile.contacts",
  data() {
    return {
      contacts: [],
      leadContact: null,
      settings: null,
      saving: false,
      saved: false,
    };
  },
  methods: {
    async getContacts() {
      let company = this.$auth.activeCompany;

      let settingsFilter = {
        Company: { Companyid: company.companyId },
      };

      // make service call
      let contactsDTO = await SettingsService.getContacts(settingsFilter);
      this.contacts = contactsDTO;
    },
  },
  async mounted() {
    await this.getContacts();
  },
};
</script>
